import i18n from 'i18next';

import * as apiGetSettingKey from 'api/setting/GetSettingV1';
import {
	getCultureCodeFromLocalStorage,
	setCultureCodeToLocalStorage,
} from 'functions/getCultureCodeFromLocalStorage';
import { getLanguageString } from 'functions/getLanguageString';
import { Optional } from 'functions/promiseExtensions';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';
import { RootState } from 'reducers/rootReducer';

export type CultureCodeType = string;

const getAllowedUiLanguagesFromApi = async () => {
	const response = await apiGetSettingKey.callApi();
	return response.map((x) => x.ui.languages.split(',')).getOrDefault([]);
};

export async function getCultureCodeFromApi(
	_: any,
	_params: any,
	state: RootState
): Promise<CultureCodeType> {
	const uiLanguages = await getAllowedUiLanguagesFromApi();
	const systemLanguages = state.languages;

	const cultureCodeFinal = Optional.Maybe(getCultureCodeFromLocalStorage())
		.or(Optional.Just(state.user.cultureCode))
		.filter((x) => systemLanguages.some((y) => y.cultureCode === x))
		.filter((x) => uiLanguages.some((y) => y === x))
		.getOrDefault(state.languages.map((x) => x.cultureCode).firstOrDefault('en-US'));

	const language: string = getLanguageString(cultureCodeFinal);
	i18n.changeLanguage(language);
	setCultureCodeToLocalStorage(cultureCodeFinal);
	return cultureCodeFinal;
}

const rb = new ReducerBuilder<CultureCodeType>();
export const cultureCodeLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'CultureCode/LoadedFromBackend'
);

export const setReduxCultureCode = rb.createActionForReducer(
	payloadReducer((x) => x),
	'CultureCode/SET'
);
export const cultureCodeReducer = rb.createReducer();
